module.exports = __webpack_public_path__ + "img/gartek-services-fire-protection-safety.385ffa4b.png";